// === calendarInitializer.js START ===============================================================

/** Initializes the FullCalendar module */
function InitCalendar() {
    var rasterString = function (minutes) {
        var hours = 0;
        while (minutes >= 60) {
            hours++;
            minutes -= 60;
        }

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        return hours + ":" + minutes;
    };

    var updateEvent = function (event, withEnd) {
        var reqObj = {
            id: event.id,
            start: event.start.format()
        };
        if (withEnd) {
            reqObj.end = event.end.format();
        }

        if (event.occurences && event.occurences.length) {
            for (var i = 0; i < event.occurences.length; i++) {
                event.occurences[i].startDate = event.start.format();
                if (withEnd) {
                    event.occurences[i].endDate = event.end.format();
                }
            }
        }

        $.ajax({
            headers: {
                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
            },
            xhrFields: { withCredentials: true },
            url: window.calendarConfiguration.apiHostName + '/updateEvent/' + window.calendarConfiguration.calendarOwnerId,
            dataType: 'json',
            type: "POST",
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(reqObj),
            success: function (response) {
                // TODO Show animation here?
                if (!response.data) {
                    Modal.alert($t("Error saving the appointment"), response.result);
                } else {
                    $calendar.fullCalendar('refetchEvents');
                }
            },
            failure: function () {
                Modal.alert($t("Error saving the appointment"), $t("Request failed"));
            }
        });
    };

    var hasAuthority = function (userType) {
        return calendarConfiguration.loginUserType === userType;
    };

    var isEditable = function () {
        if (calendarConfiguration.calendarType === 'Courses' && calendarConfiguration.loginUserType === 'Me') {
            return false;
        }

        if (calendarConfiguration.loginUserType === "Pro"
            && calendarConfiguration.loginUserId !== calendarConfiguration.calendarOwnerId
            && calendarConfiguration.calendarType !== 'Appliances'
        ) {
            return false;
        }

        if (calendarConfiguration.loginUserType === 'Club Office' &&
            calendarConfiguration.clubPermission !== 'ClubPermEdit' &&
            calendarConfiguration.clubPermission !== 'ClubPermPrivateEdit') {
            return false;
        }

        return true;
    };

    var allowPdfExport = calendarConfiguration.loginUserType === 'Pro' || calendarConfiguration.loginUserType === 'Golf Academy'
        || (calendarConfiguration.loginUserType === 'Club Office' && calendarConfiguration.clubPermission === 'ClubPermPrivateEdit');

    var isSelectable = function (selectInfo) {
        var container;
        var calendarView = $calendar.fullCalendar('getView').type;

        if (selectInfo.resourceId) {
            if (selectInfo.resourceId.split("_")[1] === undefined && calendarView === 'timelineDay') {
                return false;
            }

            var resource = FindResourceById(selectInfo.resourceId);
            if (resource) {
                if (calendarConfiguration.loginUserType === 'Golf Academy' && calendarView === 'timelineDay') {
                    return true;
                }
                container = resource.businessHours;
            }
        }

        if (GetValidBusinessHours(selectInfo.start, selectInfo.end, container)) {
            return true;
        }
        return false;
    };

    var checkIfDatesArePastNow = function () {
        var now = moment().utcOffset(0, true);
        console.info(arguments.length);
        for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (arg._isAMomentObject !== true) {
                throw "Invalid argument type: not a moment object";
            }
            if (arg.isAfter(now)) {
                console.info("skipConfirmationBecausePast -> false");
                return false;
            }
        }
        console.info("skipConfirmationBecausePast -> true");
        return true;
    };

    var UserAgent = {
        isBrowser: /Edge\/\d+/.test(navigator.userAgent) ? 'ed' : /MSIE 9/.test(navigator.userAgent) ? 'ie9' : /MSIE 10/.test(navigator.userAgent) ? 'ie10' : /MSIE 11/.test(navigator.userAgent) ? 'ie11' : /MSIE\s\d/.test(navigator.userAgent) ? 'ie?' : /rv\:11/.test(navigator.userAgent) ? 'ie11' : /Firefox\W\d/.test(navigator.userAgent) ? 'ff' : /Chrome\W\d/.test(navigator.userAgent) ? 'gc' : /Chromium\W\d/.test(navigator.userAgent) ? 'oc' : /\bSafari\W\d/.test(navigator.userAgent) ? 'sa' : /\bOpera\W\d/.test(navigator.userAgent) ? 'op' : /\bOPR\W\d/i.test(navigator.userAgent) ? 'op' : typeof MSPointerEvent !== 'undefined' ? 'ie?' : '',
        isOS: /Windows NT 10/.test(navigator.userAgent) ? "win10" : /Windows NT 6\.0/.test(navigator.userAgent) ? "winvista" : /Windows NT 6\.1/.test(navigator.userAgent) ? "win7" : /Windows NT 6\.\d/.test(navigator.userAgent) ? "win8" : /Windows NT 5\.1/.test(navigator.userAgent) ? "winxp" : /Windows NT [1-5]\./.test(navigator.userAgent) ? "winnt" : /Mac/.test(navigator.userAgent) ? "mac" : /Linux/.test(navigator.userAgent) ? "linux" : /X11/.test(navigator.userAgent) ? "nix" : "",
        isMobile: /IEMobile|Windows Phone|Lumia/i.test(navigator.userAgent) ? 'w' : /iPhone|iP[oa]d/.test(navigator.userAgent) ? 'i' : /Android/.test(navigator.userAgent) ? 'a' : /BlackBerry|PlayBook|BB10/.test(navigator.userAgent) ? 'b' : /Mobile Safari/.test(navigator.userAgent) ? 's' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(navigator.userAgent) ? 1 : 0,
        isTablet: /Tablet|iPad/i.test(navigator.userAgent),
        hasTouch: 'ontouchstart' in document.documentElement,
        updateOrientation: function () {
            this.orientation = window.orientation === 0 ? 'portrait' : 'landscape';
        }
    };
    UserAgent.updateOrientation();

    var resourcesLoader = function (callback, start, end, timezone) {
        if (calendarConfiguration.loginUserType !== 'Golf Academy' ||
            $calendar.fullCalendar('getView').type !== 'timelineDay') {
            callback(calendarConfiguration.resources);
            return;
        }

        // TODO Use ApiClient.getResources
        var url = window.calendarConfiguration.apiHostName + '/resources';
        url += "?start=" + moment(start).toISOString();
        url += '&end=' + moment(end).toISOString();

        $.ajax({
            headers: {
                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
            },
            xhrFields: { withCredentials: true },
            url: url,
            dataType: 'json',
            type: 'GET',
            error: function (daObj) {
                alert($t('Failed loading resources. Please refresh the page.'));
                console.error("Failed loading resources", daObj);
            },
            success: function (r) {
                callback(r.data);

                setTimeout(function () {
                    $calendar.fullCalendar('refetchEvents');
                },
                    500);
            }
        });
    };

    var dayWeekIcons = ", agendaDayIcon, agendaWeekIcon";
    var agendaIcons = calendarConfiguration.loginUserType === 'Golf Academy' ? ", agendaTimelineIcon" + dayWeekIcons : dayWeekIcons;

    // Mobile Safari scrolling fail
    // TODO Fix mobile safari scrolling / drag&drop
    // var preventParentScrolling = function () {
    //     console.info("[Frame] Stopping scrolling");
    //     parent.postMessage({ action: "scrolling", isLocked: true }, calendarConfiguration.webHostName);
    // };
    // var allowParentScrolling = function () {
    //     console.info("[Frame] Allowing scrolling");
    //     parent.postMessage({ action: "scrolling", isLocked: false }, calendarConfiguration.webHostName);
    // };

    var initialRaster = calendarConfiguration.calendarRaster;

    // DRY UpdateCalendar
    function UpdateCalendar(config) {
        var options = {};

        $calendar.fullCalendar('changeView', config.view);

        ChangeSize(config.view);


        if (config.raster) {
            var rasteredString = rasterString(parseInt(config.raster));

            calendarConfiguration.calendarRaster = config.raster;

            options = Object.assign(options, {
                'slotDuration': rasteredString,
                'slotLabelInterval': rasteredString
            });
        }

        if (config.range) {
            options = Object.assign(options, {
                'minTime': config.range.minTime,
                'maxTime': config.range.maxTime
            });
        }

        var bh = (config.view === "timelineDay") ? { businessHours: { start: config.range.minTime, end: config.range.minTime } } : { businessHours: window.calendarConfiguration.businessHours };
        options = Object.assign(options, bh);

        console.info("UpdateCalendar: config=", config, ", options=", options);
        $calendar.fullCalendar('option', options);
        $calendar.fullCalendar('refetchEvents');
        if (config.view === "timelineDay") {
            ObserveHeaderCamvas();
        }
    }

    //init calendar element
    var fullCalendarConfiguration = {
        defaultView: UserAgent.isTablet || UserAgent.isMobile === 'mobile' ? 'agenda' : 'agendaWeek',
        weekNumbers: true,
        weekNumberCalculation: 'ISO',
        weekNumberTitle: calendarConfiguration.weekNumberTitle,
        timeFormat: 'LT',
        slotLabelFormat: 'LT',
        editable: (!UserAgent.isTablet && !UserAgent.isMobile) && isEditable() && !hasAuthority("Me") && !hasAuthority("Anonymous"),
        droppable: (!UserAgent.isTablet && !UserAgent.isMobile) && isEditable() && !hasAuthority("Me") && !hasAuthority("Anonymous"),
        selectable: isEditable(),
        selectHelper: isEditable() && !hasAuthority("Me") && !hasAuthority("Anonymous"),
        themeSystem: 'jquery-ui',
        locale: calendarConfiguration.locale,
        slotLabelInterval: rasterString(parseInt(calendarConfiguration.calendarRaster)),
        slotDuration: rasterString(parseInt(calendarConfiguration.calendarRaster)),
        allDaySlot: false,
        eventBackgroundColor: 'rgba(58, 135, 173, 0.6)',
        eventConstraint: "businessHours",
        selectAllow: isSelectable,
        height: 'auto',
        firstDay: 1,
        businessHours: window.calendarConfiguration.businessHours,
        minTime: window.calendarConfiguration.businessHoursMinTime,
        maxTime: window.calendarConfiguration.businessHoursMaxTime,

        // This is to make an event draggable / resizable
        //eventLongPressDelay: 1000,
        // This is to make the click an an event or in an empty spot shorter
        selectLongPressDelay: 150,

        customButtons: {
            agendaTimelineIcon: {
                click: function () {
                    ApiClient.loadAcademyProList().done(function (d) {
                        academyProList = d.data.pros;
                        UpdateCalendar({
                            'raster': d.data.raster,
                            'businessHours': [],
                            'view': 'timelineDay',
                            'range': {
                                'minTime': d.data.minTime,
                                'maxTime': d.data.maxTime
                            }
                        });
                    });
                }
            },
            agendaDayIcon: {
                click: function () {
                    UpdateCalendar({
                        'raster': initialRaster,
                        'businessHours': calendarConfiguration.businessHours,
                        'view': 'agenda',
                        'range': {
                            'minTime': fullCalendarConfiguration.minTime,
                            'maxTime': fullCalendarConfiguration.maxTime
                        }
                    });
                }
            },
            agendaWeekIcon: {
                click: function () {
                    UpdateCalendar({
                        'raster': initialRaster,
                        'businessHours': calendarConfiguration.businessHours,
                        'view': 'agendaWeek',
                        'range': {
                            'minTime': fullCalendarConfiguration.minTime,
                            'maxTime': fullCalendarConfiguration.maxTime
                        }
                    });
                }
            }
        },

        themeButtonIcons: {
            selectDate: 'ui-icon-caret-1-e',
            today: 'ui-icon-bullet',
            prev: 'ui-icon-caret-1-w',
            next: 'ui-icon-caret-1-e'
        },

        header: {
            left: 'title',
            center: 'selectDate',
            right: (allowPdfExport ? 'exportPdf, ' : '')
                + 'editTextTemplates, '
                + 'exportCSV, getICal' + agendaIcons
        },

        titleFormat: 'L',

        views: {
            agenda: {
                columnHeaderFormat: 'ddd\n\rMMM D',
                slotLabelFormat: 'LT'
            }
        },
        events: function (start, end, timezone, callback) {
            var currentView = $calendar.fullCalendar('getView').type;

            var url = window.calendarConfiguration.apiHostName + '/appointment/';
            if (calendarConfiguration.calendarType === "Appliances") {
                url += "appliances/" + calendarConfiguration.currentAppliance.id;
            } else if (calendarConfiguration.calendarType === 'Courses' && $calendar.fullCalendar("getView").type !== 'timelineDay') {
                url += 'courses/' + calendarConfiguration.clubId;
            } else if (currentView !== 'timelineDay') {
                url += window.calendarConfiguration.calendarOwnerId;
            }
            url += "?start=" + moment(start).toISOString();
            url += '&end=' + moment(end).toISOString();
            url += '&utcOffset=' + moment().utcOffset();

            if (currentView === 'timelineDay') {
                url += '&view=timelineDay';
            }
            console.info("#####################" + window.calendarConfiguration.apiHostName);
            $.ajax({
                headers: {
                    'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
                },
                xhrFields: { withCredentials: true },
                url: url,
                dataType: 'json',
                type: 'GET',
                error: function (daObj) {
                    alert($t('Failed loading appointments. Please refresh the page.'));
                    console.error("Failed loading appointments", daObj);
                },
                beforeSend: function () {
                    $(".loader").show();
                },
                complete: function () {
                    $(".loader").hide();
                },
                success: function (result) {
                    var events = [];

                    if (hasAuthority("Me")) {
                        for (var i = 0; i < result.data.length; i++) {
                            if (result.data[i].appointmentType === "SingleTraining"
                                || result.data[i].appointmentType === "MultiTraining"
                                || result.data[i].appointmentType === "Package") {
                                result.data[i].className = "fc-me-selectable";
                            }
                        }
                    }

                    if (hasAuthority("Pro") && (calendarConfiguration.calendarType === "Appliances") && result.data && result.data.length) {
                        for (var eventIdx = 0; eventIdx < result.data.length; eventIdx++) {
                            var singleEvent = result.data[eventIdx];

                            if (singleEvent.participants && singleEvent.participants.length) {
                                for (var participantIdx = 0; participantIdx < singleEvent.participants.length; participantIdx++) {
                                    var loopedParticipant = singleEvent.participants[participantIdx];
                                    singleEvent.title = loopedParticipant.firstName + ' ' + loopedParticipant.lastName;
                                    break;
                                }
                            }
                        }
                    }

                    events = events.concat(CreateLocationBackgroundEvents(result.data, start));
                    events = events.concat(result.data);

                    callback(events);
                }
            });

            function CreateResourceBackgroundEvents(resource, appointments, calendarStartDate) {
                var backgroundEvents = [];
                var utcNow = moment().utcOffset(0, true); // Get the current time as fake UTC.
                var checkBookable = typeof calendarConfiguration.futureBookingThreshold === 'number' &&
                    calendarConfiguration.futureBookingThreshold >= 0;
                var renderAsLocationLetter =
                    calendarConfiguration.resources && calendarConfiguration.resources.length > 1;

                for (var kbh in resource.businessHours) {
                    if (resource.businessHours.hasOwnProperty(kbh)) {
                        var bh = resource.businessHours[kbh];

                        var bhTimes = GetBusinessHourMomentObjects(bh);

                        var finalEnd = bhTimes.end;

                        var start;
                        var end = moment(bhTimes.start);

                        var calculateDow = (bh.dow[0] - 1 % 7);

                        var dow = calculateDow < 0 ? 7 + calculateDow : calculateDow;

                        var buffer = 0;

                        if (calendarConfiguration.loginUserType === 'Me') {

                            buffer = calendarConfiguration.bookingThreshold
                                ? -calendarConfiguration.bookingThreshold
                                : 0;
                        }

                        var day = moment(calendarStartDate).startOf('isoweek').add(dow, 'day');

                        do {
                            start = moment(end);
                            end.add(calendarConfiguration.calendarRaster, 'minutes');

                            var startDate = moment(day)
                                .hours(start.format('HH'))
                                .minutes(start.format('mm'))
                                .seconds(0)
                                .milliseconds(0);
                            var endDate = moment(day)
                                .hours(end.format('HH'))
                                .minutes(end.format('mm'))
                                .seconds(0)
                                .milliseconds(0);

                            var isFree = moment(startDate).add(buffer, 'hours') > utcNow;

                            var isBookable =
                                checkBookable
                                    ? startDate <=
                                    moment(utcNow).add(calendarConfiguration.futureBookingThreshold, 'day')
                                    : true;

                            if (isFree) {
                                // check if an appointment exists in current time slot
                                for (var i = 0; i < appointments.length; i++) {
                                    var app = appointments[i];
                                    if (app.resourceIds.some(function (id) {
                                        return id === resource.id;
                                    }) &&
                                        startDate >= moment.utc(app.start) &&
                                        endDate <= moment.utc(app.end)) {
                                        isFree = false;
                                        break;
                                    }
                                }
                            }

                            var resourceEvent = {
                                start: start.format('HH:mm'),
                                end: end.format('HH:mm'),
                                dow: bh.dow,
                                rendering: 'background',
                                backgroundColor: 'transparent',
                                resourceId: resource.id,
                                resource: resource,
                                renderAsLocationLetter: renderAsLocationLetter,
                                isFree: isFree,
                                bookable: isBookable
                            };
                            backgroundEvents.push(resourceEvent);
                        }
                        while (end < finalEnd);
                    }
                }

                return backgroundEvents;
            }

            function CreateLocationBackgroundEvents(appointments, calendarStartDate) {
                var backgroundEvents = [];

                // When in timeline view (academy), create background events for all clubs and pros. Otherwise only for the current active pro.
                var resources = $calendar.fullCalendar('getView').type === 'timelineDay'
                    ? $calendar.fullCalendar('getResources')
                    : calendarConfiguration.resources;
                for (var kr in resources) {
                    if (resources.hasOwnProperty(kr)) {
                        var resource = resources[kr];
                        backgroundEvents = backgroundEvents.concat(CreateResourceBackgroundEvents(resource,
                            appointments,
                            calendarStartDate));
                        for (var crk in resource.children) {
                            if (resource.children.hasOwnProperty(crk)) {
                                var childResource = resource.children[crk];
                                backgroundEvents = backgroundEvents.concat(
                                    CreateResourceBackgroundEvents(childResource, appointments, calendarStartDate));
                            }
                        }
                    }
                }
                return backgroundEvents;
            }
        },

        refetchResourcesOnNavigate: true,
        resources: resourcesLoader,

        schedulerLicenseKey: '0038291571-fcs-1540459964',

        select: function (start, end, jsEvent, view, resource) {
            if (!isEditable()) {
                return;
            }

            if (calendarConfiguration.isPublicCalendar) {
                Modal.show({
                    title: $t("Me and My Pro"),
                    content: $t('{0}Registrieren Sie sich bitte hier{1}, um diesen Termin buchen zu können oder {2}melden Sie sich mit einem bereits bestehendem Account an.{3}').format('<a href="' + window.calendarConfiguration.webHostName + '/Register?regtype=student" target="_blank" style="color: #547e00;">', '</a>', '<a href="' + window.calendarConfiguration.webHostName + '/" target="_blank" style="color: #547e00;">', '</a>'),
                    actions: [{
                        title: $t("OK"),
                        icon: "icon-check",
                        onClick: function () {

                        }
                    }]
                });
                return;
            }

            var utcNow = moment().utcOffset(0, true);

            if (calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === 'Anonymous') {
                if (IsOverlappingWithAnyEvent(start, end)) {
                    // Note - the blue stain cannot be removed or cancelled using jsEvent.preventDefault()
                    console.info("Cancelling click - ME and ANONYMOUS are not allowed to create overlapping appointments.")
                    return;
                }

                if (start < utcNow) {
                    console.info("Cancelling click - past time selected");
                    return;
                }

                if (calendarConfiguration.calendarType === 'Courses') {
                    console.info('Cancelling click - ME cannot create appointments in course type calendars.');
                    return;
                }

                // Reset the "end" time for students, they are not allowed to set it themselves.
                end = moment(start).add(calendarConfiguration.calendarRaster, 'minutes');

                // Deadline für Buchung (Stunden)
                if (typeof calendarConfiguration.bookingThreshold === "number" &&
                    calendarConfiguration.bookingThreshold > 0) {
                    var deadlineTime = moment(utcNow).add(calendarConfiguration.bookingThreshold, "hours");
                    if (deadlineTime > start) {
                        Modal.show({
                            title: $t("Deadline für Buchung"),
                            content: $t("Termine müssen mindestens {0} Stunden im Voraus gebucht werden").format(calendarConfiguration.bookingThreshold),
                            actions: [{
                                title: $t("OK"),
                                icon: "icon-check",
                                onClick: function () {

                                }
                            }]
                        });
                        return;
                    }
                }
                // Im Voraus buchbar (Tage)
                if (typeof calendarConfiguration.futureBookingThreshold === "number" &&
                    calendarConfiguration.futureBookingThreshold > 0) {
                    var maximumBookingTime = moment(utcNow).add(calendarConfiguration.futureBookingThreshold, "days").toDate().getTime();
                    if (maximumBookingTime < start) {
                        Modal.show({
                            title: $t("Im Voraus buchbar"),
                            content: $t("Termine können höchstens {0} Tage im Voraus gebucht werden").format(calendarConfiguration.futureBookingThreshold),
                            actions: [{
                                title: $t("OK"),
                                icon: "icon-check",
                                onClick: function () {

                                }
                            }]
                        });
                        return;
                    }
                }
            }

            // The type step will automatically proceed to a single training for mes
            currentEvent = null;
            var step = "type";

            if (calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === 'Anonymous') {
                currentEvent = {
                    appointmentType: "SingleTraining"
                };
                step = "appointment";
            }

            if (calendarConfiguration.calendarType === "Appliances") {
                currentEvent = {
                    start: start,
                    end: end,
                    appointmentType: "Utility",
                    appliance: calendarConfiguration.currentAppliance
                };
                step = "appointment";
            }

            if (calendarConfiguration.loginUserType === 'Golf Academy' && resource && !resource.parent) {
                currentResource = resource;
            } else {
                var bh = GetValidBusinessHours(start, end, resource ? resource.businessHours : undefined);

                if (!bh) {
                    // This happens if someone clicks on a grey area (pro) in the scheduler
                    return;
                }

                if (bh.resourceId) {
                    currentResource = resource || GetLocationById(bh.resourceId);
                }
            }

            OpenModal(step, start, end);
        },

        eventClick: function (event, jsEvent, view) {
            if (jsEvent.target.className.contains("fc-info")) {
                return;
            }

            if (calendarConfiguration.isPublicCalendar) {
                Modal.show({
                    title: $t("Me and My Pro"),
                    content: $t('{0}Registrieren Sie sich bitte hier{1}, um diesen Termin buchen zu können oder {2}melden Sie sich mit einem bereits bestehendem Account an.{3}').format('<a href="' + window.calendarConfiguration.webHostName + '/Register?regtype=student" target="_blank" style="color: #547e00;">', '</a>', '<a href="' + window.calendarConfiguration.webHostName + '/" target="_blank" style="color: #547e00;">', '</a>'),
                    actions: [{
                        title: $t("OK"),
                        icon: "icon-check",
                        onClick: function () {

                        }
                    }]
                });
            } else {
                if (event.editable === false) {
                    return;
                }

                if (calendarConfiguration.loginUserType === 'ClubOffice' && calendarConfiguration.clubPermission !== 'ClubPermEdit' && calendarConfiguration.clubPermission !== 'ClubPermPrivateEdit') {
                    return;
                }

                if (calendarConfiguration.loginUserType === "Me" &&
                    typeof calendarConfiguration.futureBookingThreshold === "number" &&
                    calendarConfiguration.futureBookingThreshold > 0) {

                    var utcNow = moment().utcOffset(0, true);

                    var maximumBookingTime = utcNow.add(calendarConfiguration.futureBookingThreshold, "days");

                    if (event.start > maximumBookingTime) {
                        Modal.show({
                            title: $t("Im Voraus buchbar"),
                            content: $t("Termine können höchstens {0} Tage im Voraus gebucht werden").format(calendarConfiguration.futureBookingThreshold),
                            actions: [{
                                title: $t("OK"),
                                icon: "icon-check",
                                onClick: function () {
                                }
                            }]
                        });
                        return;
                    }
                }

                currentEvent = event;

                if (event.constraint && event.constraint.resourceIds && event.constraint.resourceIds.length) {
                    if (calendarConfiguration.loginUserType === 'Golf Academy') {
                        currentResource = FindResourceById(event.constraint.resourceIds.slice(-1)[0]) || GetLocationById(event.constraint.resourceIds[0]); // The last element should be the pro in this specific club. Fallback to the club only.
                    } else {
                        currentResource = GetLocationById(event.constraint.resourceIds[0]); // club should always be first, see AppointmentController:230ff for reference.
                    }
                }

                OpenModal("appointment");
            }
        },

        eventDrop: function (event, delta, revertFunc) {
            if (!hasAuthority("Me") && !hasAuthority("Me")) {
                var dateBefore = moment(event.start).subtract(delta);
                if (checkIfDatesArePastNow(event.start, event.end, dateBefore)) {
                    updateEvent(event, false);
                    return;
                }
                Modal.show({
                    title: $t("Move Appointment") + ': ' + event.title,
                    content: $t("Would you like to move the appointment from {0} to {1}?").format(dateBefore.format('L') + ' ' + dateBefore.format('LT'), event.start.format('L') + ' ' + event.start.format('LT')),
                    actions: [
                        {
                            title: $t("Cancel"),
                            icon: "icon-cancel",
                            onClick: function () {
                                revertFunc();
                            }
                        },
                        {
                            title: $t("Rebook"),
                            icon: "icon-check",
                            onClick: function () {
                                updateEvent(event, false);
                            }
                        }
                    ]
                });
            } else {
                revertFunc();
            }
        },

        eventResize: function (event, delta, revertFunc) {
            if (!hasAuthority('Me')) {
                if (checkIfDatesArePastNow(event.start, event.end)) {
                    updateEvent(event, true);
                    return;
                }
                Modal.show({
                    title: $t('Change appointment duration'),
                    content: $t('Do you want to change the term duration') + '? ' + $t('Selected appointment') + ': ' + event.end.format('LT'),
                    actions: [
                        {
                            title: $t('Abbrechen'),
                            icon: 'icon-cancel',
                            onClick: function () {
                                revertFunc();
                            }
                        },
                        {
                            title: $t('Umbuchen'),
                            icon: 'icon-check',
                            onClick: function () {
                                updateEvent(event, true);
                            }
                        }
                    ]
                });
            } else {
                revertFunc();
            }
        },

        // eventDragStart: preventParentScrolling,
        // eventDragStop: allowParentScrolling,
        // eventResizeStart: preventParentScrolling,
        // eventResizeStop: allowParentScrolling,

        eventRender: function (event, $elem, view) {

            var utcNow = moment().utcOffset(0, true);
            var isMeOrAnonymous = calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === 'Anonymous';

            if (moment(event.start) < utcNow) {
                if (event.appointmentId) {
                    $elem.addClass("fc-disable-event");
                }
            }
            // Actually add the location letter on letter background events.
            if (event.renderAsLocationLetter && event.resource && event.resource.letter) {
                var _class = '';
                if (moment(event.start) < utcNow || !event.bookable && isMeOrAnonymous) {
                    _class = ' fc-disable';
                }
                var $letter = $('<div class="fc-bgevent__location-letter' + _class + '">' + event.resource.letter + '</div>');
                $elem.append($letter);
            }
            if (event.resource) {
                if (event.isFree && (event.bookable || !isMeOrAnonymous)) {
                    var $free = $('<div class="fc-bgevent__location-free">' + $t('Frei') + '</div>');
                    $elem.append($free);
                }
                if (!event.bookable && isMeOrAnonymous) {
                    var $notbookable = $('<div class="fc-bgevent__location-no-bookable">' + $t('Nicht buchbar') + '</div>');
                    $elem.append($notbookable);
                }
            }

            if (event.appointmentId && calendarConfiguration.loginUserType !== 'Anonymous') {
                // Appointment Type     Users   Description
                // Group training       Pro     Everyone
                // Single training      *       *       (only pro and related me)
                // Absence              Pro     *       (only if published)
                // Package              Pro     Everyone

                var $tooltipContainer = $("<div>");
                $tooltipContainer.addClass("fc-info-container");
                $tooltipContainer.appendTo($elem);

                //Participant list
                if (!isMeOrAnonymous && event.appointmentType !== "SingleTraining") {
                    var participantsList = event.participants && event.participants.length
                        ? event.participants.map(function (item) {
                            return item['firstName'] + ' ' + item['lastName'];
                        })
                        : [];

                    if (participantsList.length) {
                        var eventTooltip1 = $("<i>")
                            .attr("title", participantsList)
                            .addClass("fc-info icon-user");
                        eventTooltip1.appendTo($tooltipContainer);
                        SetEventTooltip(eventTooltip1);
                    }
                }
                //show info icons only if not im schedular mode
                if ($calendar.fullCalendar("getView").type !== 'timelineDay') {
                    //Fills the info icon with information (if exists) (Appointment Occurrence Description and Appointment Type)
                    if (event.template || event.description) {
                        var eventTooltip2 = $("<i>")
                            .attr("title", "")
                            .addClass("fc-info icon-info");

                        //As the description can include all sorts of characters,
                        //a simple character-divided string (like with the title attribute)
                        //doesn't cut it here, instead we need a new data attribute
                        if (event.template) {
                            eventTooltip2.attr("data-occurrenceAppointmentType", event.template.title);
                        }
                        if (event.description) {
                            eventTooltip2.attr("data-desc", event.description);
                        }
                        if (event.appliance && event.appliance.name) {
                            eventTooltip2.attr("data-appliance", event.appliance.name);
                        }

                        eventTooltip2.appendTo($tooltipContainer);
                        SetEventTooltip(eventTooltip2);
                    }

                    //Payment Status
                    if (event.appointmentType === "SingleTraining" && event.participants.length) {
                        var dataDesc = $t(event.participants[0].paymentStatus);
                        if (!!event.participants[0].paymentStatusDate) {
                            dataDesc += " ";
                            dataDesc += event.participants[0].paymentStatusDate;
                        }

                        var eventPayment = $("<i>")
                            .attr("title", "")
                            .attr("data-desc", dataDesc)
                            .addClass("fc-info fc-info-text")
                            .text(calendarConfiguration.currencySymbol);
                        eventPayment.appendTo($tooltipContainer);
                        SetEventTooltip(eventPayment);
                    }

                    //Contact information list (Telephone number / Email Address)
                    //Contains "fullName", "phoneNumber" and "email"
                    if (!isMeOrAnonymous && event.participants && event.participants.length) {
                        var contactProperties = ["phoneNumber", "email"];
                        var filteredParticipantsList =
                            GetFilteredArrayByAnyProperty(event.participants, contactProperties);

                        if (filteredParticipantsList.length && filteredParticipantsList.length > 0) {
                            var mappedParticipantsList =
                                GetMappedParticipantsWithContactInformation(filteredParticipantsList);

                            var eventPhoneInfo = $("<i>")
                                .attr("title", "")
                                .attr("data-desc", "")
                                .attr("data-contactList", ConvertParticipantsToContactListString(mappedParticipantsList))
                                .addClass("fc-info icon-phone");
                            eventPhoneInfo.appendTo($tooltipContainer);
                            SetEventTooltip(eventPhoneInfo);
                        }
                    }

                    //Card Information
                    if (event.meCardInformation) {
                        var eventCardInfo = $("<i>")
                            .attr("title", "")
                            .attr("data-desc", event.meCardInformation)
                            .addClass("fc-info icon-credit-card");
                        eventCardInfo.appendTo($tooltipContainer);
                        SetEventTooltip(eventCardInfo);
                    }
                }
            }

            if (event.id && event.id === calendarConfiguration.autoOpenOccurenceId) {
                currentEvent = event;
                OpenModal("appointment");
                calendarConfiguration.autoOpenOccurenceId = null;
            }
        },

        eventAfterAllRender: function () {
            ModifyToolbar();
            ModifyAgendaTimelineIconButton();
            ModifyAgendaDayIconButton();
            ModifyAgendaWeekIconButton();
            CloneHeaderAsFooter();

            if (window.performResize) {
                setTimeout(window.performResize, 100);
            }
        }
    };

    if (calendarConfiguration.startDate) {
        // Format is validated by backend
        var startDateMoment = moment(calendarConfiguration.startDate);
        if (startDateMoment.isValid()) {
            fullCalendarConfiguration.defaultDate = startDateMoment;
        }
    }

    window.fullCalendarConfiguration = fullCalendarConfiguration;
    $calendar.fullCalendar(fullCalendarConfiguration);

    UserAccessStateDetection();
    MobileCalendarDetection();

    /**
     * The Header of the calendar should also be on the end
     */
    function CloneHeaderAsFooter() {
        var isScheduler = $calendar.fullCalendar('getView').type === "timelineDay";

        $('tfoot.tc-foot').remove();
        var $calendarHeader = $('thead.fc-head > tr');

        if (isScheduler) {
            // Only replace first
            $calendarHeader[0].querySelector(".fc-cell-text").innerText = $t("Uhrzeit");
        }

        var $placed = $('<tfoot class="tc-foot"></tfoot>').append($calendarHeader.clone()).appendTo('.fc-view > table');

        if (!isScheduler) {
            return;
        }

        var $sourceScroller = $calendarHeader.find("th[data-date]").parents(".fc-scroller");
        var $targetCanvas = $placed.find("th[data-date]").parents(".fc-scroller-canvas");

        $sourceScroller.on("scroll", function () {
            // scroller.x minus scroller->canvas.x
            var offset = $sourceScroller[0].children[0].getBoundingClientRect().x - $sourceScroller[0].getBoundingClientRect().x;
            $targetCanvas.css("margin-left", offset + "px");
        });
    }

    function UserAccessStateDetection() {
        var notMonetized = Boolean(calendarConfiguration.notMonetized);
        var contentSuppressor = $("#fc-user-nopremium");
        var calendarElement = $(".m-mamp-calendar, .m-mamp-premium-info");
        var initial = $(".contents-initial");
        var seeyougo = $(".contents-seeyougo");

        $(document).ready(function () {
            if (notMonetized && !!contentSuppressor) {
                contentSuppressor.show();
                calendarElement.css("filter", "blur(2px)");

                replaceHref($(".text-tos a"), "#", window.calendarConfiguration.webHostName + "/information/agb");
                replaceHref($(".text-dataprivacy a"), "#", window.calendarConfiguration.webHostName + "/information/privacy");
                replaceHref($(".button-wrap #mm-popup--button-payment"), "#", window.calendarConfiguration.webHostName + "/buymepremium");
                replaceHref($(".contents-seeyougo .button-wrap #mm-popup--button-close"), "#", window.calendarConfiguration.webHostName + "/");

                $(".contents-initial .button-wrap #mm-popup--button-decline").click(function () {
                    // Maybe some logic to lock the user?

                    initial.hide();
                    seeyougo.show();
                });
            }
        });
    }

    function replaceHref(el, oldHref, newHref) {
        el.each(function () {
            var currentHref = $(this).attr('href');
            if (currentHref === oldHref) {
                $(this).attr('href', newHref);
            }
        });
    }

    function ChangeSize(x) {
        parent.postMessage(JSON.stringify({
            "action": "changeView",
            "view": x
        }), "*");
    };

    /**
     * Modifies the FullCalendar toolbar:
     * - moves the 'week' and 'day' view buttons into a custom container
     * - adds a custom settings container (for club labels, etc.)
     * - adds a row wrapper for toolbar contents
     * - adds custom toolbar content
     */
    function ModifyToolbar() {
        $('.fc-toolbar').each(function () {
            var $this = $(this);

            // add header row with day/week buttons
            if (!$this.children('.fc-toolbar__calendar-views-container').length) {
                var $divCalendarViewsContainer = CreateElement(
                    'div', 'fc-toolbar__calendar-views-container');

                if (calendarConfiguration.loginUserType === 'Golf Academy') {
                    $('.fc-agendaTimelineIcon-button').each(function () {
                        $divCalendarViewsContainer.append(this);
                        SetEventTooltip($(this));
                    });
                }
                $('.fc-agendaDayIcon-button').each(function () {
                    $divCalendarViewsContainer.append(this);
                    SetEventTooltip($(this));
                });
                $('.fc-agendaWeekIcon-button').each(function () {
                    $divCalendarViewsContainer.append(this);
                    SetEventTooltip($(this));
                });
                $this.prepend($divCalendarViewsContainer);
            }

            // add header row with event club type definitions
            if (!$this.children('.fc-toolbar__settings-container').length) {
                var $divSettingsContainer = CreateElement(
                    'div',
                    'fc-toolbar__settings-container',
                    null);
                var counter = 0;
                for (var kc in calendarConfiguration.resources) {
                    if (calendarConfiguration.resources.hasOwnProperty(kc)) {
                        var resource = calendarConfiguration.resources[kc];

                        var letter = "";
                        counter++;
                        if (calendarConfiguration.resources.length > 1) {
                            letter = '<span class="fc-toolbar__settings-container__location__letter">' +
                                resource.letter +
                                '</span>';
                        }

                        $divSettingsContainer.append($(
                            '<div id="location' + counter + '"class="fc-toolbar__settings-container__location">' +
                            letter +
                            '<span class="fc-toolbar__settings-container__location__title">' +
                            (resource.overrideTitle || resource.title) +
                            '</span></div>'));
                    }
                }
                $this.prepend($divSettingsContainer);
            }

            // wrap left, center and right
            if (!$this.children('.fc-toolbar__first-row').length) {
                var $divFirstRow = CreateElement('div', 'fc-toolbar__first-row');
                $divFirstRow.append($this.find('.fc-left')[0]);
                $divFirstRow.append($this.find('.fc-center')[0]);
                $divFirstRow.append($this.find('.fc-right')[0]);

                if (calendarConfiguration.whiteLabelColor) {
                    $divFirstRow.css("background-color", calendarConfiguration.whiteLabelColor);
                }

                $this.prepend($divFirstRow);
            }

            // remove fc-clear
            if ($this.children('.fc-clear').length) {
                $this.children('.fc-clear').remove();
            }

            // add center toolbar content
            $this.find('.fc-center').each(function () {
                var $center = $(this);

                // select date button
                var $dateButton = CreateIconButton('date', 'icon-down-open');
                if ($dateButton) {
                    var $datepicker = InitDatepicker(calendarConfiguration.locale, $center);
                    $dateButton.prepend($t('Wähle Datum'));
                    $dateButton.click(function () {
                        $datepicker.datepicker("setDate", $calendar.fullCalendar('getDate').toDate());
                        $datepicker.show();
                    });
                    $center.prepend($dateButton);
                }

                // next button
                var $nextButton = CreateIconButton('next', 'icon-right-open');
                if ($nextButton) {
                    $nextButton.click(function () {
                        $calendar.fullCalendar('next');
                    });
                    $center.prepend($nextButton);
                }

                // today button
                var $todayButton = CreateIconButton('today', 'icon-record');
                if ($todayButton) {
                    $todayButton.click(function () {
                        $calendar.fullCalendar('today');
                    });
                    $center.prepend($todayButton);
                }

                // previous button
                var $prevButton = CreateIconButton('prev', 'icon-left-open');
                if ($prevButton) {
                    $prevButton.click(function () {
                        $calendar.fullCalendar('prev');
                    });
                    $center.prepend($prevButton);
                }
            });

            var getExportLink = function (type) {
                var start = $calendar.fullCalendar('getView').start;
                var url = calendarConfiguration.apiHostName +
                    '/export?type=' +
                    type +
                    '&start=' +
                    start.unix() +
                    '000&userGuid=' +
                    calendarConfiguration.calendarOwnerId +
                    '&calendarType=' + calendarConfiguration.calendarType;
                return url;
            };

            // add right toolbar content
            $this.find('.fc-right').each(function () {
                if (!calendarConfiguration.loginUserId) {
                    return;
                }

                var $right = $(this);

                // pdf export button
                if (allowPdfExport) {
                    var $pdfButton = CreateImageButton(
                        '/assets/Svg/Icon-PDF.svg',
                        $t('export to PDF'),
                        'pdf',
                        $t('export to PDF'));
                    if ($pdfButton) {
                        $pdfButton.click(function () {
                            window.open(getExportLink('pdf'), '_blank');
                        });
                        $right.append($pdfButton);
                    }
                }

                if (calendarConfiguration.loginUserType !== "Me") {
                    // text template button
                    var $textButton = CreateImageButton(
                        '/assets/Svg/Icon-Text.svg',
                        $t('create template'),
                        'text',
                        $t('Create a text template four your appointments'));
                    if ($textButton) {
                        $textButton.click(function () {
                            OpenModal("textTemplates");
                        });
                        $right.append($textButton);
                    }


                    // csv export button
                    var $csvButton = CreateImageButton(
                        '/assets/Svg/Icon-CSV.svg',
                        $t('Export to CSV'),
                        'csv',
                        $t('Export to CSV'));
                    if ($csvButton) {
                        $csvButton.click(function () {
                            window.open(getExportLink('csv'), '_blank');
                        });
                        $right.append($csvButton);
                    }
                }

                if (calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === 'Pro') {
                    // iCal export button
                    var $iCalButton = CreateImageButton(
                        '/assets/Svg/Icon-ICAL.svg',
                        $t('Get iCal link'),
                        'ical',
                        $t('Get iCal link'));
                    var $iCalFloater = $(Handlebars.partials['iCalFloatingContainer']());
                    if ($iCalButton) {
                        $iCalButton.click(function () {
                            var top = $iCalButton.height() + 15;
                            var right = $(window).width() - $iCalButton.width() - $iCalButton.offset().left;
                            $iCalFloater.css({
                                'top': top,
                                'right': right
                            });
                            $iCalFloater.slideToggle(200);
                            //window.open(getExportLink('ical'), '_blank');
                        });
                        $iCalFloater.find('#ical-close').click(function () {
                            $iCalFloater.slideUp(200);
                        });
                        $iCalFloater.find('#ical-newlink')
                            .click(function () {
                                ApiClient.regenerateICalLink()
                                    .done(function (d) {
                                        var url = d.data;
                                        $iCalFloater.find('#ical-link-input').val(url);
                                    }).fail(function (d) {
                                        $iCalFloater.find('#ical-link-input').val($t('Fehler aufgetreten.'));
                                    });
                            });
                        $iCalFloater.find('#ical-copylink')
                            .click(function () {
                                window.prompt('', $iCalFloater.find('#ical-link-input').val());
                            });
                        $right.append($iCalButton);
                        $right.append($iCalFloater);
                    }
                }
            });

            /** Helper to create an image button in the toolbar */
            function CreateImageButton(imgSrc, imgAlt, btnVariant, btnTitle) {
                if ($this.find('.fc-toolbar__image-button--' + btnVariant).length > 0) {
                    return null;
                }
                var $image = CreateElement('img', 'fc-toolbar__image-button-image');
                $image.attr('src', imgSrc);
                $image.attr('alt', imgAlt);
                var $button = CreateElement(
                    'button',
                    'fc-toolbar__image-button fc-toolbar__image-button--' + btnVariant);
                $button.attr('type', 'button');
                $button.attr('title', btnTitle);
                $button.append($image);
                return $button;
            }

            /** Helper to create an icon button in the toolbar */
            function CreateIconButton(btnVariant, iconClass, title) {
                if ($this.find('.fc-toolbar__icon-button--' + btnVariant).length > 0) {
                    return;
                }
                var $icon = $(document.createElement('i'));
                $icon.addClass(iconClass);
                var $button = CreateElement(
                    'button',
                    'fc-toolbar__icon-button fc-toolbar__icon-button--' + btnVariant);
                $button.attr('type', 'button');
                $button.attr('title', title);
                $button.append($icon);
                return $button;
            }
        });
    }

    /** Removes all CSS classes instead the main class. */
    function ModifyAgendaTimelineIconButton() {
        $('.fc-agendaTimelineIcon-button').each(function () {
            var $button = $(this);
            $button.text('');
            $button.attr('title', $t('Calendar.Views.Scheduler'));
            $button.removeClass();
            $button.addClass('fc-agendaTimelineIcon-button');
        });
    }

    /** Removes all CSS classes instead the main class. */
    function ModifyAgendaDayIconButton() {
        $('.fc-agendaDayIcon-button').each(function () {
            var $button = $(this);
            $button.text('');
            $button.attr('title', $t('Calendar.Views.Day'));
            $button.removeClass();
            $button.addClass('fc-agendaDayIcon-button');
        });
    }

    /** Removes all CSS classes instead the main class. */
    function ModifyAgendaWeekIconButton() {
        $('.fc-agendaWeekIcon-button').each(function () {
            var $button = $(this);
            $button.text('');
            $button.attr('title', $t('Calendar.Views.Week'));
            $button.removeClass();
            $button.addClass('fc-agendaWeekIcon-button');
        });
    }

    function MobileCalendarDetection() {
        UserAgent.updateOrientation();

        var $dayButton = $("button.fc-agendaDayIcon-button");
        var $weekButton = $("button.fc-agendaWeekIcon-button");
        var $timelineButton = $("button.fc-agendaTimelineIcon-button");
        var view = UserAgent.orientation === 'portrait' && UserAgent.isMobile && !UserAgent.isTablet ? 'agenda' : 'agendaWeek';

        $dayButton.hide();
        $weekButton.hide();
        $timelineButton.hide();

        if (UserAgent.isMobile && UserAgent.orientation === 'landscape' || (UserAgent.isTablet || !UserAgent.isTablet && !UserAgent.isMobile)) {
            $dayButton.show();
            $weekButton.show();
            $timelineButton.show();
        }

        $calendar.fullCalendar('changeView', view);
        if ($calendar.fullCalendar("opt").businessHours !== window.calendarConfiguration.businessHours) {
            $calendar.fullCalendar("option", {
                businessHours: window.calendarConfiguration.businessHours,
                minTime: calendarConfiguration.businessHoursMinTime,
                maxTime: calendarConfiguration.businessHoursMaxTime
            });
            $calendar.fullCalendar("reinitView");
        }
    }

    if (calendarConfiguration.calendarType === "Courses" && calendarConfiguration.loginUserType === "Me") {
        // Eager-load pro list
        ApiClient.loadAcademyProList(calendarConfiguration.clubId).done(function (d) {
            academyProList = d.data.pros;
        });
    }

    var $infoLabel = $('#versionInfo--api');
    if ($infoLabel.length) {
        ApiClient.getApiVersion()
            .done(function (d) {
                $infoLabel.text(d.data);
            });
    }

    window.addEventListener('message', function (e) {
        if (e && e.data && e.data.action) {
            if (e.data.action === 'parentScroll') {
                window.parentScrollOffset = e.data.offset;
            }
            if (e.data.action === "orientationChange") {
                MobileCalendarDetection();
                UserAgent.orientation = window.orientation === 0 ? 'portrait' : 'landscape';
            }
        }
    });

    var getCookieValue = function (name) {
        var result = "";
        var cookieArray = document.cookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            if (cookieArray[i].indexOf(name) !== -1) {
                result = cookieArray[i].split('=')[1];
            }
        }
        return result;
    };

    // fix for footer canvas sizing: MAMP-1580
    function ObserveHeaderCamvas() {
        var observedHeaderCamvas = document.querySelector('.fc-head .fc-time-area .fc-scroller-canvas');
        if (!!observedHeaderCamvas) {
            var config = { attributes: true, childList: false, subtree: false };

            // Create an observer instance linked to the callback function
            var observer = new MutationObserver(function () {
                CloneHeaderAsFooter();
            });

            // Start observing the target node for configured mutations
            observer.observe(observedHeaderCamvas, config);
        }
    }

}

// === calendarInitializer.js END =================================================================
